jQuery(document).ready(function ($) {
	// ---------------------------------------------------------------------
	// | instagram feed                                                    |
	// ---------------------------------------------------------------------
	var instagramFeedTotalData = 0;
	var instagramFeedLimitData = 8;
	var instagramFeedData = Array();
	if ($(".js-instagram-feed").length) {
		$(".js-instagram-feed").each(function () {
			var thisInstagramFeed = $(this);
			// var accessToken = $this.find('.js-access-token').attr('val');

			var accessToken = thisInstagramFeed
				.find(".js-access-token")
				.attr("val");
			var accountID = thisInstagramFeed
				.find(".js-account-ID")
				.attr("val");
			getInstagramBusiness(thisInstagramFeed, accountID, accessToken);
		});
	}

	function getInstagramBusiness(thisInstagramFeed, accountID, accessToken) {
		$.getJSON(
			"https://graph.facebook.com/v6.0/" +
				accountID +
				"?fields=instagram_business_account&access_token=" +
				accessToken +
				"&callback=?",
			function (data) {
				var businessAccountID = data.instagram_business_account.id;
				// console.log(businessAccountID);
				getInstagramAllMedia(
					thisInstagramFeed,
					businessAccountID,
					accessToken
				);
			}
		);
	}

	function getInstagramAllMedia(
		thisInstagramFeed,
		businessAccountID,
		accessToken
	) {
		$.getJSON(
			"https://graph.facebook.com/" +
				businessAccountID +
				"/media?access_token=" +
				accessToken +
				"&callback=?",
			function (media) {
				$.each(media.data, function (index, data) {
					if (index < instagramFeedLimitData) {
						mediaID = data.id;
						// console.log(mediaID);
						getInstagramAllMediaDetail(
							thisInstagramFeed,
							mediaID,
							accessToken
						);
					}
				});
			}
		);
	}

	function getInstagramAllMediaDetail(
		thisInstagramFeed,
		mediaID,
		accessToken
	) {
		$.getJSON(
			"https://graph.facebook.com/" +
				mediaID +
				"?fields=caption,id,media_type,media_url,permalink,owner,timestamp,like_count,comments_count,thumbnail_url&access_token=" +
				accessToken +
				"&callback=?",
			function (data) {
				instagramFeedData.push(data);
				instagramFeedTotalData++;
				if (instagramFeedTotalData == instagramFeedLimitData) {
					// console.log(instagramFeedData);
					renderInstagramFeed(thisInstagramFeed, instagramFeedData);
				}
			}
		);
	}

	function renderInstagramFeed(thisInstagramFeed, instagramFeedData) {
		instagramFeedData = instagramFeedData.sort(function (a, b) {
			var reg = /-|:|T|\+/; //The regex on which matches the string should be split (any used delimiter) -> could also be written like /[.:T\+]/
			var parsed = [
				//an array which holds the date parts for a and b
				a.timestamp.split(reg), //Split the datestring by the regex to get an array like [Year,Month,Day,Hour,...]
				b.timestamp.split(reg),
			];
			var dates = [
				//Create an array of dates for a and b
				new Date(
					parsed[0][0],
					parsed[0][1],
					parsed[0][2],
					parsed[0][3],
					parsed[0][4],
					parsed[0][5]
				), //Constructs an date of the above parsed parts (Year,Month...
				new Date(
					parsed[1][0],
					parsed[1][1],
					parsed[1][2],
					parsed[1][3],
					parsed[1][4],
					parsed[1][5]
				),
			];
			return dates[1] - dates[0]; //Returns the difference between the date (if b > a then a - b < 0)

			// return (new Date(a.timestamp).getTime() < new Date(b.timestamp).getTime()) ? 1 : ((new Date(a.timestamp).getTime() > new Date(b.timestamp).getTime()) ? -1 : 0);
		});

		$.each(instagramFeedData, function (index, data) {
			// console.log(data);
			var id = data.id;
			var link = data.permalink;
			var image = data.media_url;
			var caption = data.caption;
			var timestamp = data.timestamp;
			var like_count = data.like_count;
			var comments_count = data.comments_count;
			var media_type = data.media_type;
			var date = new Date(timestamp);

			if (media_type == "VIDEO") {
				image = data.thumbnail_url;
			}

			m = date.getMonth();
			d = date.getDate();
			y = date.getFullYear();

			var month_names = new Array();
			month_names[month_names.length] = "January";
			month_names[month_names.length] = "Februari";
			month_names[month_names.length] = "March";
			month_names[month_names.length] = "April";
			month_names[month_names.length] = "May";
			month_names[month_names.length] = "June";
			month_names[month_names.length] = "July";
			month_names[month_names.length] = "August";
			month_names[month_names.length] = "September";
			month_names[month_names.length] = "October";
			month_names[month_names.length] = "November";
			month_names[month_names.length] = "December";

			var thetime = month_names[m] + " " + d + " " + y;

			// console.log(id);
			// console.log(thetime);
			// console.log(media_type);

			var template =
				'<div class="carousel-cell" data-id="' +
				id +
				'" data-date="' +
				thetime +
				'" data-media-type="' +
				media_type +
				'">' +
				'<a href="' +
				link +
				'" target="_blank" class="crisp-image lazy-bg" data-bgurl="' +
				image +
				'" style="background-image:url(data:image/gif;base64,R0lGODlhAQABAJEAAAAAAP///////wAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFAAACACwAAAAAAQABAAACAlQBADs=);">' +
				'<div class="overlay">' +
				'<ul class="actions">' +
				'<li class="title">' +
				caption +
				"</li>" +
				'<li><i class="fa fa-heart" aria-hidden="true"></i>' +
				like_count +
				"</li>" +
				'<li><i class="fa fa-comment" aria-hidden="true"></i>' +
				comments_count +
				"</li>" +
				"</ul>" +
				"</div>" +
				"</a>" +
				"</div>";

			// console.log(template);

			thisInstagramFeed
				.find(".js-instagram-feed-carousel")
				.append(template);

			// if (window.loadLazyBGimage) {
			// 	var tg = thisInstagramFeed.find(".lazy-bg").last();
			// 	console.log("🚀 ~ file: instagram-feed.js:200 ~ tg:", tg)
			// 	// window.loadLazyBGimage(tg);
			// }

			if (index + 1 == instagramFeedLimitData) {
				// init carousel
				// var $carousel = thisInstagramFeed.find('.js-instagram-feed-carousel').flickity({
				// 	autoPlay: 5000,
				// 	freeScroll: false,
				// 	wrapAround: false,
				// 	cellAlign: 'left',
				// 	cellSelector: '.carousel-cell'
				// });

				// $carousel.flickity( 'select', 1 );
				// var flkty = $carousel.data('flickity');
				// when only one slide - add class to hide dots/arrows and disable dragging
				// if ($carousel.length) {
				// 	if (flkty.cells.length < 2) {
				// 		flkty.unbindDrag();
				// 		$carousel.addClass('single-slide');
				// 	}
				// }
				// if hidden on page load, resize when shown
				if (!thisInstagramFeed.is(":visible")) {
					$(".js-home-connect-toggler").on("click", function () {
						$carousel.flickity("resize");
					});
				}
			}
		});

		if (instagramFeedData.length) {
			window.startIOlazybg();
		}
	}
});
